<form [formGroup]="fG">
  <div [class.e-error]="fG.controls[fCN].invalid && fG.controls[fCN].dirty">
    <ejs-timepicker
      [placeholder]="placeholder"
      [formControlName]="fCN"
      [cssClass]="cssClass"
      [step]="step">
    </ejs-timepicker>
  </div>
</form>